<template>
    <div class="skin-padding-l">
        <div class="row">
            <div class="col-lg-8">
                <div class="pwd-generator-wrapper">
                    <div class="pwd-strength-text" :style="{color: color}">
                        {{ passwordStrength }}
                    </div>
                    <div class="pwd-generator-password mgb40"
                         :style="{borderBottom: '2px solid ' + color}">
                        <span id="pwd-input" class="pwd-generator-password-title hidden-text"
                              :style="{fontSize: passwordFontSize + 'px'}">
                            {{ password }}
                        </span>
                        <button class="tooltip-target icon-button icon-regenerate visible-hover"
                                @click="generatePassword"
                                data-toggle="tooltip" title="Genereaza o noua parola">
                            <svg class="icon-size" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                <path
                                    d="M 8,1 A 7,7 0 0 0 1,8 L 2,8 A 6,6 0 0 1 8,2 6,6 0 0 1 12.916016,4.583984 L 11.5,6 15,6 15,2.5 13.634766,3.865234 A 7,7 0 0 0 8,1 Z m 6,7 A 6,6 0 0 1 8,14 6,6 0 0 1 3.0898438,11.410156 L 4.5,10 1,10 1,13.5 2.3671875,12.132812 A 7,7 0 0 0 8,15 7,7 0 0 0 15,8 l -1,0 z"
                                    fill="#bcbcbc"></path>
                            </svg>
                        </button>
                        <button id="input-copy-button" class="copy-button tooltip-target"
                                ref="copyBtn" @click="copyToClipboard"
                                data-toggle="tooltip" title="Click pentru a copia parola in clipboard.">
                            COPIAZA
                        </button>
                    </div>
                    <div class="pwd-input-length mgb40">
                        <div>Marime parola</div>
                        <input id="pwd-input-number"
                               v-model="passwordLength" @input="generatePassword" type="number" min="4" max="64">
                        <input id="slider" type="range" min="4" max="64" class="range" step="1"
                               v-model="passwordLength" @input="generatePassword">
                    </div>
                    <div class="pwd-checkboxes">
                        <label class="pwd-checkbox-wrapper" data-toggle="tooltip" title="Litere mari">
                            Majuscule
                            <input id="uppercase" name="uppercase" type="checkbox" checked
                                   v-model="uppercase" @change="generatePassword">
                            <span class="checkmark"></span>
                        </label>
                        <label class="pwd-checkbox-wrapper" data-toggle="tooltip" title="Litere mici">
                            Minuscule
                            <input id="lowercase" name="lowercase" type="checkbox" checked
                                   v-model="lowercase" @change="generatePassword">
                            <span class="checkmark"></span>
                        </label>
                        <label class="pwd-checkbox-wrapper">
                            Numere
                            <input id="numbers" name="numbers" type="checkbox" checked
                                   v-model="numbers" @change="generatePassword">
                            <span class="checkmark"></span>
                        </label>
                        <label class="pwd-checkbox-wrapper">
                            Simboluri
                            <input id="symbols" name="symbols" type="checkbox" checked
                                   v-model="symbols" @change="generatePassword">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <img src="/images/password-generator/password-generator.jpg" class="img-resp hidden visible-lg"
                     alt="">
            </div>
        </div>
    </div>

    <div class="skin-padding-l hidden" v-if="false">
        <div class="row">
            <div class="col-lg-8">
                <div class="px-1 pr-3">
                    <div class="form-group text-center text-light-green">
                        <h3 id="password-strength" class="font-weight-bold"
                            :style="{color: color}">
                            {{ passwordStrength }}
                        </h3>
                    </div>
                    <div class="form-group">
                        <div class="p-3 password-input text-right"
                             :style="{borderBottom: '2px solid ' + color}">
                            <div class="my-1 mx-2 absolute text-left" style="width: 65%">
                                {{ password }}
                            </div>

                            <span @click="generatePassword" class="btn pointer text-muted"
                                  data-toggle="tooltip" title="Genereaza o noua parola"
                                  style="font-size: 18px;">
                                <span class="fa fa-refresh"></span>
                            </span>&nbsp;
                            <button ref="copyBtn" @click="copyToClipboard" class="btn btn-light-green">
                                COPY
                            </button>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col-sm-6">
                            Password Length:
                            <input v-model="passwordLength" type="text" id="passwordLength"
                                   style="width: 50px; display: inline-block"
                                   class="ml-2 text-center form-control">
                        </div>
                        <div class="col-sm-6 pt-2">
                            <input v-model="passwordLength" type="range" min="4" max="64" step="1"
                                   @input="generatePassword" id="password-length" class="pointer">
                        </div>
                    </div>
                    <div class="form-group mt-5 text-center-lg">
                        <div class="checkbox-inline">
                            <input v-model="uppercase" type="checkbox" id="uppercase"
                                   @change="generatePassword" class="align-middle">
                            <label for="uppercase">Uppercase</label>
                        </div>
                        <div class="checkbox-inline">
                            <input v-model="lowercase" type="checkbox" id="lowercase"
                                   @change="generatePassword">
                            <label for="lowercase">Lowercase</label>
                        </div>
                        <div class="checkbox-inline">
                            <input v-model="numbers" type="checkbox" id="numbers"
                                   @change="generatePassword">
                            <label for="numbers">Numbers</label>
                        </div>
                        <div class="checkbox-inline">
                            <input v-model="symbols" type="checkbox" id="symbols"
                                   @change="generatePassword">
                            <label for="symbols">Symbols</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <img src="/images/password-generator/password-generator.jpg" class="img-resp hidden visible-lg"
                     alt="">
            </div>
        </div>
    </div>

</template>

<script setup>
import {computed, onMounted, ref} from 'vue'

const passwordLength = ref(15)
const uppercase = ref(true)
const lowercase = ref(true)
const numbers = ref(true)
const symbols = ref(true)
const password = ref('')
const passwordFontSize = ref(19.5)

const VERY_WEAK = 'Foarte slaba'
const WEAK = 'Slaba'
const GOOD = 'Buna'
const STRONG = 'Puternica'
const VERY_STRONG = 'Foarte puternica'

const showTooltip = ref(false)

const generatePassword = () => {
    let passwordValue = '';
    let characters = '';
    let indexes = {lowercase: 0, uppercase: 0, number: 0, symbol: 0}
    let lowercaseCharacters = 'abcdefghijklmnopqrstuvwxyz'
    let uppercaseCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    let numberCharacters = '0123456789'
    let symbolCharacters = '!@#$%^&*()_+-=[]{};:,.<>/?|\\'

    if (lowercase.value) {
        characters += lowercaseCharacters;
        indexes.lowercase = 1;
    }
    if (uppercase.value) {
        characters += uppercaseCharacters;
        indexes.uppercase = 1;
    }
    if (numbers.value) {
        characters += numberCharacters
        indexes.number = 1;
    }
    if (symbols.value) {
        characters += symbolCharacters
        indexes.symbol = 1;
    }

    if (!characters) return;

    for (let i = 0; i < passwordLength.value; i++) {
        if (indexes.lowercase) {
            passwordValue += lowercaseCharacters.charAt(Math.floor(Math.random() * lowercaseCharacters.length));
            indexes.lowercase = 0;
        } else if (indexes.uppercase) {
            passwordValue += uppercaseCharacters.charAt(Math.floor(Math.random() * uppercaseCharacters.length));
            indexes.uppercase = 0;
        } else if (indexes.number) {
            passwordValue += numberCharacters.charAt(Math.floor(Math.random() * numberCharacters.length));
            indexes.number = 0;
        } else if (indexes.symbol) {
            passwordValue += symbolCharacters.charAt(Math.floor(Math.random() * symbolCharacters.length));
            indexes.symbol = 0;
        } else {
            passwordValue += characters.charAt(Math.floor(Math.random() * characters.length));
        }
    }
    password.value = passwordValue;

    updateFontSize()
}

const updateFontSize = () => {
    if (password.value.length <= 30) {
        passwordFontSize.value = 19.5
    } else if (password.value.length > 30 && password.value.length <= 40) {
        passwordFontSize.value = 19.5 - ((password.value.length - 30) / 1.4);
    } else if (password.value.length > 40 && password.value.length <= 50) {
        passwordFontSize.value = 19.5 - ((password.value.length - 30) / 2.3);
    } else if (password.value.length > 50 && password.value.length <= 60) {
        passwordFontSize.value = 19.5 - ((password.value.length - 30) / 2.6);
    } else if (password.value.length > 60) {
        passwordFontSize.value = 19.5 - ((password.value.length - 30) / 3.1);
    }
}

const copyToClipboard = () => {
    const textarea = document.createElement('textarea')
    textarea.value = password.value
    document.body.appendChild(textarea)
    textarea.select()
    try {
        document.execCommand('copy')
    } catch (err) {
        console.log('Failed to copy text')
    }
    textarea.remove()

    showTooltip.value = true
}

const passwordStrength = computed(() => {
    let passwordValue = password.value

    if ((uppercase && lowercase && numbers) || (uppercase && symbols && numbers) || (lowercase && symbols && numbers)) {
        if (passwordValue.length >= 4 && passwordValue.length <= 4) {
            return VERY_WEAK
        } else if (passwordValue.length >= 5 && passwordValue.length <= 7) {
            return WEAK
        } else if (passwordValue.length >= 8 && passwordValue.length <= 10) {
            return GOOD
        } else if (passwordValue.length >= 11 && passwordValue.length <= 13) {
            return STRONG
        } else if (passwordValue.length >= 14) {
            return VERY_STRONG
        }
    } else if ((uppercase && numbers) || (lowercase && numbers) || (symbols && numbers)) {
        if (passwordValue.length >= 4 && passwordValue.length <= 4) {
            return VERY_WEAK
        } else if (passwordValue.length >= 5 && passwordValue.length <= 8) {
            return WEAK
        } else if (passwordValue.length >= 9 && passwordValue.length <= 12) {
            return GOOD
        } else if (passwordValue.length >= 13 && passwordValue.length <= 16) {
            return STRONG
        } else if (passwordValue.length >= 17) {
            return VERY_STRONG
        }
    } else if ((uppercase && lowercase) || (uppercase && symbols) || (lowercase && symbols)) {
        if (passwordValue.length >= 4 && passwordValue.length <= 4) {
            return VERY_WEAK
        } else if (passwordValue.length >= 5 && passwordValue.length <= 7) {
            return WEAK
        } else if (passwordValue.length >= 8 && passwordValue.length <= 11) {
            return GOOD
        } else if (passwordValue.length >= 12 && passwordValue.length <= 14) {
            return STRONG
        } else if (passwordValue.length >= 15) {
            return VERY_STRONG
        }
    } else if (uppercase || lowercase || symbols) {
        if (passwordValue.length >= 4 && passwordValue.length <= 5) {
            return VERY_WEAK
        } else if (passwordValue.length >= 6 && passwordValue.length <= 9) {
            return WEAK
        } else if (passwordValue.length >= 10 && passwordValue.length <= 13) {
            return GOOD
        } else if (passwordValue.length >= 14 && passwordValue.length <= 18) {
            return STRONG
        } else if (passwordValue.length >= 18) {
            return VERY_STRONG
        }
    } else if (numbers) {
        if (passwordValue.length >= 4 && passwordValue.length <= 7) {
            return VERY_WEAK
        } else if (passwordValue.length >= 8 && passwordValue.length <= 13) {
            return WEAK
        } else if (passwordValue.length >= 14 && passwordValue.length <= 19) {
            return GOOD
        } else if (passwordValue.length >= 20 && passwordValue.length <= 25) {
            return STRONG
        } else if (passwordValue.length >= 26) {
            return VERY_STRONG
        }
    }
})

const color = computed(() => {
    if (passwordStrength.value === VERY_WEAK) {
        return '#ff0909';
    } else if (passwordStrength.value === WEAK) {
        return '#ff8f8f'
    } else if (passwordStrength.value === GOOD) {
        return '#f2c148'
    } else if (passwordStrength.value === STRONG) {
        return '#9cff8b'
    } else if (passwordStrength.value === VERY_STRONG) {
        return '#83f24c'
    }
})

onMounted(generatePassword)

</script>

<style scoped lang="scss">

.password-input {
    padding: 8px 5px 8px 15px;
    border-radius: 4px;
    box-shadow: rgb(184 185 184) -1px 4px 10px -1px;
}

/* ESET Style */
.pwd-generator-wrapper {
    display: inline-flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    min-width: 500px;
    font-family: "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    font-size: 17px;
    line-height: 1.52941em;

    .mgb40 {
        margin-bottom: 40px;
    }

    .pwd-strength-text {
        font-size: 32px;
        font-weight: 600;
        margin-bottom: 10px;
    }

    .pwd-generator-password {
        width: 100%;
        display: flex;
        flex-direction: row;
        background: white;
        padding: 8px 5px 8px 15px;
        border-radius: 4px;
        box-shadow: rgb(184 185 184) -1px 4px 10px -1px;
        align-items: center;
        justify-content: space-around;
        box-sizing: border-box;
        transition: border-color 0.5s ease 0s;
        cursor: text;
        text-align: left;
        border-bottom: 3px solid #554;

        .pwd-generator-password-title {
            font-size: 20px;
            width: 100%;
            display: inline-block;
        }

        .icon-regenerate {
            margin-top: 3px;
            display: flex;
        }

        .icon-button {
            background: none;
            color: inherit;
            border: none;
            padding: 0px;
            font: inherit;
            cursor: pointer;
            outline: inherit;
            display: flex;
            align-items: center;

            .icon-size {
                width: 25px;
                height: 25px;
            }
        }

        .copy-button {
            border: none;
            background: rgb(141, 198, 48);
            color: rgb(255, 255, 255);
            width: 100%;
            font-size: 15px;
            cursor: pointer;
            border-radius: 5px;
            max-width: 85px;
            line-height: 2.5;
            padding: 0px 10px;
            margin-left: 10px;
            margin-right: 3px;
            height: 37px;
        }
    }

    .pwd-input-length {
        flex-flow: row wrap;
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;

        input[type="number"] {
            border-radius: 7px;
            text-align: center;
            border: 1px solid rgb(219, 220, 219);
            padding: 5px 0px;
            margin: 0px 20px;
            width: 70px;
        }

        input[type="range"] {
            width: 50%;
            cursor: pointer;
        }
    }

    .checkmark {
        position: absolute;
        top: 3px;
        left: 0px;
        height: 20px;
        width: 20px;
        background-color: white;
        border-radius: 5px;
        box-shadow: rgb(184 185 184) 1px 1px 3px 0px;
    }

    .checkmark::after {
        content: "";
        position: absolute;
        display: none;
    }

    .pwd-checkboxes {
        flex-flow: row wrap;
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        text-align: left;

        .pwd-checkbox-wrapper {
            display: block;
            position: relative;
            padding-left: 30px;
            margin-bottom: 12px;
            cursor: pointer;
            user-select: none;
            margin-right: 15px;
            height: 30px;
            font-weight: 400;

            input {
                position: absolute;
                opacity: 0;
                cursor: pointer;
                height: 0px;
                width: 0px;
            }

            input:checked ~ .checkmark {
                background-color: white;
            }

            input:checked ~ .checkmark::after {
                display: block;
            }

            .checkmark::after {
                left: 9px;
                top: 4px;
                width: 4px;
                height: 10px;
                border-style: solid;
                border-color: rgb(0, 150, 161);
                border-image: initial;
                border-width: 0px 2px 2px 0px;
                transform: rotate(45deg);
            }
        }
    }
}


</style>
